<template>
  <div class="wrapper">
    <lastpage :homeShow="false"></lastpage>
    <div class="ewm">
      <vue-qr
        :logoSrc="imageUrl"
        :text="dataCard.patientId"
        :logoScale="50"
        :size="180"
        :margin="0"
        :logoCornerRadius="0"
      ></vue-qr>
    </div>
    <ul class="list_calss">
      <li>
        <span>姓名</span>
        <span>{{dataCard.patientname}}</span>
      </li>
      <li>
        <span>身份证号</span>
        <span>{{dataCard.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1*********$2")}}</span>
      </li>
      <li>
        <span>就诊ID号</span>
        <span>{{dataCard.patientId}}</span>
      </li>
      <li>
        <span>手机号</span>
        <span>{{dataCard.telno.replace(/(\w{2})\w*(\w{2})/, "$1*******$2")}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import imageUrl from "@/assets/index/nrhc.png"
import lastpage from "@/components/lastpage/lastpage.vue";
import VueQr from 'vue-qr'
export default {
  components: {
    VueQr,
    lastpage
  },
  data() {
    return {
      dataCard: {},
      imageUrl //默认二维码中间图片
    };
  },
  created() {
    this.dataCard = JSON.parse(sessionStorage.getItem("card"));
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .ewm{
    text-align: center;
    background: #fff;
    padding: 20px 0px;
  }
  .list_calss{
    margin-top: 10px;
    display: flex;
    flex-flow: column nowrap;
    background: #fff;
    font-size: 16px;
    >li{
      padding: 10px 20px;
      border-bottom: 1px solid #eee;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/HealthCard.vue